<template>
  <div>
    <b-navbar :fixed-top="true" class="shdw">
      <div>
        <div class="p-5"></div>
      </div>
    </b-navbar>
    <div
      class="card"
      style="max-width: 400px; margin: 50px auto; padding: 20px;"
    >
      <div class="card-content">
        <div v-if="!emailSent">
          <h2 class="is-size-4 has-text-weight-bold">Sign in with email</h2>
          <h3 class="is-size-6 mt-1 has-text-grey-dark">
            We will send a link to your email to login without a password
          </h3>
          <form @submit.prevent="requestMagicLink">
            <div class="form-group">
              <label for="email" class="has-text-weight-bold mt-4"
                >Email Address:</label
              >
              <input
                type="email"
                id="email"
                v-model="email"
                required
                placeholder="Enter your email address"
                :disabled="loading"
              />
            </div>
            <button type="submit" :disabled="loading">
              {{ loading ? "Sending..." : "Send Login Link" }}
            </button>
          </form>

          <div class="conditions mt-2">
            <p class="text-center has-text-grey is-size-7">
              By signing in, you agree to our
              <a
                id="termsAndConditions"
                class="teal-text has-text-weight-bold"
                :href="this.$appConfig.gantGatewayUrl + '/terms-and-conditions'"
                >Terms and Conditions</a
              >
            </p>
          </div>
        </div>
        <div v-else class="success-message">
          <h2 class="is-size-4 has-text-weight-bold">Check Your Email</h2>
          <h3 class="is-size-6 mt-3 mb-3 has-text-grey-dark">We've sent a magic link to {{ email }}.</h3>
          <p class="mb-3">Click the link in the email to sign in.</p>
          <button @click="resetForm">Send Another Link</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MagicLinkLogin",
  data() {
    return {
      email: "",
      loading: false,
      emailSent: false,
      error: null,
    }
  },
  methods: {
    async requestMagicLink() {
      this.loading = true
      this.error = null

      try {
        const baseUrl = process.env.VUE_APP_HUDDLELABS_API_BASE_URL
        const username = process.env.VUE_APP_HUDDLELABS_API_USERNAME
        const password = process.env.VUE_APP_HUDDLELABS_API_PASSWORD
        const basicAuth = btoa(username + ":" + password)

        const myHeaders = new Headers()
        myHeaders.append("Authorization", `Basic ${basicAuth}`)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("X-Requested-With", "XMLHttpRequest")

        // Get the query string from the URL
        const qs = window.location.search
        const queryString = qs.startsWith("?") ? qs.substring(1) : qs

        console.log("queryString", queryString)

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          redirect: "follow",
          body: JSON.stringify({
            email: this.email,
            queryString: queryString,
          }),
        }

        const response = await fetch(
          baseUrl + "auth/magic-link",
          requestOptions
        )

        this.emailSent = true
      } catch (err) {
        this.error = err.response?.data?.message || "An error occurred"
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.email = ""
      this.emailSent = false
      this.error = null
    },
  },
}
</script>

<style scoped>
.magic-link-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #A4393A;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* .success-message {
  text-align: center;
} */
</style>
